<template>
  <div id="app"
       v-loading="loading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <router-view v-if="$route.name == 'dataCollect'"></router-view>
    <router-view v-else></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      menuList: [],
      loading: true,
      permissionList: []
    };
  },
  watch: {
    '$route.name' () {
      if (this.$route.name === 'login') {
        this.$store.state.crumbArr = [];
      }
    }
  },
  created () {
    this.loading = true;
    if (localStorage.getItem('realName')) {
      this.loading = false;
    } else {
      this.loading = false;
    }
  },
  mounted () {
  },
  methods: {
  }
};
</script>

<style src="./common/css/index.scss" lang="scss"></style>
<style>
  #app {
    height: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue